import { useState } from 'react';
import { noSelectionKey } from '../../../../../../utilities/filterAndSortingsUtil';
import { useDispatch } from 'react-redux';
import {
  setIsCreateInvitationGroupPanelOpen,
  setIsDeleteInvitationGroupPanelOpen,
  setIsUpdateInvitationGroupPanelOpen,
  setIsManageInvitationKeysPanelOpen,
} from '../../../../../../features/pageFeatures/invitationGroupAdministrationPageSlice';

export const useInteractions = () => {
  const dispatch = useDispatch();

  const [selectedInvitationGroupKey, setSelectedInvitationGroupKey] = useState(
    noSelectionKey,
  );

  function isGroupSelected(groupId) {
    return groupId === selectedInvitationGroupKey;
  }

  function onGroupClick(groupId) {
    setSelectedInvitationGroupKey((prevSelectedKey) => {
      if (groupId === prevSelectedKey) {
        return noSelectionKey;
      } else {
        return groupId;
      }
    });
  }

  function handleCreateInvitationGroup() {
    dispatch(setIsCreateInvitationGroupPanelOpen(true));
  }

  function handleUpdateInvitationGroup() {
    dispatch(setIsUpdateInvitationGroupPanelOpen(true));
  }

  function handleDeleteInvitationGroup() {
    dispatch(setIsDeleteInvitationGroupPanelOpen(true));
  }

  function handleManageInvitationKeys() {
    dispatch(setIsManageInvitationKeysPanelOpen(true));
  }

  return {
    selectedInvitationGroupKey,
    setSelectedInvitationGroupKey,
    isGroupSelected,
    onGroupClick,
    handleCreateInvitationGroup,
    handleUpdateInvitationGroup,
    handleDeleteInvitationGroup,
    handleManageInvitationKeys,
  };
};
